// extracted by mini-css-extract-plugin
export default {"task-deadline":"styles_task-deadline__7O7sW","task-deadline-date":"styles_task-deadline-date__nIuFT","task-deadline-error":"styles_task-deadline-error__IAZaq"};